import { render, staticRenderFns } from "./OrderGroupDetail.vue?vue&type=template&id=3fc1d5d6&scoped=true&"
import script from "./OrderGroupDetail.vue?vue&type=script&lang=js&"
export * from "./OrderGroupDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrderGroupDetail.vue?vue&type=style&index=0&id=3fc1d5d6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc1d5d6",
  null
  
)

export default component.exports